import { useEffect, useState } from 'react';
import { CircularProgress, IconButton, TextField } from '@material-ui/core';
import { makeStyles } from "@material-ui/core/styles";

import CheckIcon from '@material-ui/icons/CheckSharp';
import CancelIcon from '@material-ui/icons/ClearSharp';

import { sleep } from '../utils/timing';


const useStyles = makeStyles(theme => ({
  iconProgress: {
    color: theme.palette.secondary.light,
  },
  text: {
    float: 'left',
  },
}));

function TextFieldEditable(props) {
  const { id, value, setValue, onSave, className, ...textFieldProps } = props;

  const myClasses = useStyles();
  const [headerEdited, setHeaderEdited] = useState(false);
  const [lastValue, setLastValue] = useState();
  const [loading, setLoading] = useState();
  const [success, setSuccess] = useState();

  useEffect(() => {
    async function onLoad() {
      setHeaderEdited(false);
      setLastValue(value);
    }
    onLoad();
  }, [id]);

  async function onEdit(event) {
    setHeaderEdited(event.target.value != lastValue);
    setValue(event.target.value);
  }

  async function onUserCancel() {
    setValue(lastValue);
    setHeaderEdited(false);
  }

  async function onUserSave() {
    setLoading(true);
    const res = onSave(value);
    if (res) {
      setLastValue(value);
      // Briefly show spinner after save is complete.
      await sleep(1000);
      setHeaderEdited(false);
    }
    setLoading(false);
  }

  const OKButton = () => (
    <IconButton
      size='small'
      onMouseUp={onUserSave} // Without this, need to click the icon twice. https://github.com/mui/material-ui/issues/4532
      onClick={onUserSave}
    >
      {loading ?
        null :
        <CheckIcon />
      }
    </IconButton>
  )

  const CancelButton = () => (
    <IconButton
      size='small'
      onMouseUp={onUserCancel}
      onClick={onUserCancel}
    >
      {loading ?
        <CircularProgress size={24} className={myClasses.iconProgress} /> :
        <CancelIcon />
      }
    </IconButton>
  )

  return (<>
    <TextField
      className={myClasses.text}
      value={value}
      InputProps={{
        className: className,
        endAdornment: (headerEdited && onSave) ? <><OKButton /><CancelButton /></> : null,
      }}
      onChange={onEdit}
      inputProps={{ onKeyDown: (e) => {if (e.key === 'Enter') {onUserSave()}} }}
      {...textFieldProps}
    />
  </>);
}

export default TextFieldEditable;
